import { RecoverSuccessPage } from "@/features/auth/pages/RecoverSuccess";

const RecoverSuccess = () => {
  return <RecoverSuccessPage />;
};

export default RecoverSuccess;
